import API from "../../../app/api";

export const getLivetheart = async () => {
  try {
    const res = await API.get("/banners/section/LIVE_THE_ART_OF_HOME");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Live the Art items");
    }
    return res.data.data?.banners || [];
  } catch (error) {
    console.error("getLivetheart error:", error);
    return [];
  }
};